export default "__VITE_ASSET__096c313e__"